import { NppesPhysician } from "../models/PhysicianDetails";
import { rules } from "../utils/validations/Validations";

export enum GetNPPESDataActionDispatchTypes {
  GET_NPPES_DATA_INVOKE = "GET_NPPES_DATA_INVOKE",
  GET_NPPES_DATA_SUCCESS = "GET_NPPES_DATA_SUCCESS",
  GET_NPPES_DATA_RESET = "GET_NPPES_DATA_RESET",
}

export enum PhysicianDetailsDetailsHeader {
  NPI = "NPI:",
  PHYSICIAN_NAME = "Physician Name:",
}

export const physicianInitialData: NppesPhysician = {
  physicianName: "",
  physicianNpiId: "",
  phoneExt: "",
  phoneNo: "",
  streetName1: "",
  streetName2: "",
  fax: "",
  county: "",
  city: "",
  physicianState: "",
  zipCode: "",
  physicianAddress: "",
};

export const primaryPhysicianFormNames = {
  physicianName: "primaryPhysician.physicianName",
  physicianNpiId: "primaryPhysician.physicianNpiId",
  phoneNo: "primaryPhysician.phoneNo",
  phoneExt: "primaryPhysician.phoneExt",
  taxId: "primaryPhysician.taxId",
  address: [
    "primaryPhysician.streetName1",
    "primaryPhysician.streetName2",
    "primaryPhysician.city",
    "primaryPhysician.county",
    "primaryPhysician.physicianState",
    "primaryPhysician.zipCode",
    "primaryPhysician.latitude",
    "primaryPhysician.longitude",
  ],
  fax: "primaryPhysician.fax",
};

export const NppesNameErrorMsg = "Last Name or First Name is required.";

export const NPPESinitialRecord: NppesPhysician[] = [
  {
    physicianName: "",
    physicianNpiId: "",
    physicianAddress: "",
    phoneNo: "",
    phoneExt: "",
    county: "",
    streetName1: "",
    streetName2: "",
    fax: "",
    city: "",
    physicianState: "",
    zipCode: "",
  },
];

export enum NppesApiCall {
  BY_NPI = "byNpi",
  BY_NAME = "byName",
}

export const physicianNames = {
  ordering: "orderingPhysicianPhysicianName",
  primary: "primaryPhysicianPhysicianName",
};

export const physicianFormProps = (physicianFormName: string) => {
  if (physicianFormName === physicianNames.primary) {
    return {
      physicianName: "Primary Care Physician Name: ",
      physicianNpi: "Primary Care Physician NPI: ",
      rule: rules.physicianName,
    };
  }

  return {
    physicianName: "Ordering Prescriber Name: ",
    physicianNpi: "Ordering Prescriber NPI: ",
    rule: rules.orderingPrescriber,
  };
};
